import {
  ActionModel,
  AssessmentModel,
  FindingModel,
  SiteAssessmentFindingsActionsModel,
} from "../models/assesment.model";

import { AssetModel, SiteModel } from "../models/asset.model";
import { createAction, props } from "@ngrx/store";

export const ADD_ASSESMENT = createAction(
  "ADD_ASSESMENT",
  (assesment: AssessmentModel) => assesment,
);

export const UPDATE_ASSESMENT = createAction(
  "UPDATE_ASSESMENT",
  (assesment: AssessmentModel) => ({ assesment }),
);

export const ADD_ASSESMENTS = createAction(
  "ADD_ASSESMENTS",
  (assesments: AssessmentModel[]) => ({
    assesments,
  }),
);

export const UPDATE_ASSESMENTS = createAction(
  "UPDATE_ASSESMENTS",
  (assesment: AssessmentModel) => ({ assesment }),
);

export const REMOVE_ASSESMENT = createAction("REMOVE_ASSESMENT");

export const REMOVE_ALL_ASSESMENTS = createAction("REMOVE_ALL_ASSESMENTS");

export const ADD_FINDING = createAction(
  "ADD_FINDING",
  (finding: FindingModel) => finding,
);

export const ADD_ACTION = createAction(
  "ADD_ACTION",
  (action: ActionModel) => action,
);

export const ADD_IMAGE = createAction("ADD_IMAGE");

export const ADD_FINDINGS = createAction(
  "ADD_FINDINGS",
  (findings: FindingModel[]) => ({ findings }),
);

export const ADD_ACTIONS = createAction(
  "ADD_ACTIONS",
  (actions: ActionModel[]) => ({ actions }),
);

export const UPDATE_FINDING = createAction(
  "UPDATE_FINDING",
  (finding: FindingModel) => ({ finding }),
);

export const UPDATE_ACTION = createAction(
  "UPDATE_ACTION",
  (action: ActionModel) => ({ action }),
);

export const ADD_ASSESSMENT_SITE = createAction(
  "ADD_ASSESSMENT_SITE",
  props<SiteModel>(),
);
export const UPDATE_ASSESSMENT_SITE = createAction(
  "UPDATE_ASSESSMENT_SITE",
  props<SiteModel>(),
);
export const ADD_ASSET = createAction("ADD_ASSET", props<AssetModel>());
export const REMOVE_ASSESSMENT_SITE = createAction("REMOVE_ASSESSMENT_SITE");
export const UPDATE_ASSET = createAction("UPDATE_ASSET", props<AssetModel>());

export const ADD_SITE_ASSESSMENTS = createAction(
  "ADD_SITE_ASSESSMENTS",
  (assessment: SiteAssessmentFindingsActionsModel) => ({
    assessment,
  }),
);
